import React from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import XMarkIcon from 'Assets/icons/circle-xmark.svg';

const StatusEditSchema = Yup.object().shape({
    title: Yup.string().required('This value is required'),
    description: Yup.string().nullable(),
});

export default function GeneralRiskStatusesTableEditRow(props) {
    return (
        <tr>
            <Formik
                initialValues={{
                    title: props.status.title,
                    description: props.status.description ?? '',
                }}
                validationSchema={StatusEditSchema}
                onSubmit={(values, actions) => {
                    const data = { ...values };

                    axios
                        .put(props.updateUrl, data)
                        .then(() => {
                            props.onCancel();
                            props.onUpdated();
                            $('#general-risk-status-update-toast').toast('show');
                        })
                        .catch((e) => {
                            actions.setSubmitting(false);
                            $('#general-risk-status-update-failed-toast').toast('show');
                        });
                }}
            >
                {({ errors, touched, isSubmitting, handleSubmit }) => (
                    <>
                        <td className="tw-align-top">
                            <Field
                                type="text"
                                className={`tw-block tw-w-full tw-rounded-lg tw-text-sm tw-bg-grey/50 tw-text-charcoal ${
                                    errors.title && touched.title ? 'is-invalid border border-danger' : ''
                                }`}
                                name="title"
                                placeholder={$t('title')}
                                disabled={!props.status.removable}
                            />
                        </td>
                        <td>
                            <Field
                                as="textarea"
                                className={`tw-block tw-w-full tw-rounded-lg tw-text-sm tw-bg-grey/50 tw-text-charcoal tw-resize-none hover:tw-resize-y ${
                                    errors.description && touched.description ? 'is-invalid border border-danger' : ''
                                }`}
                                name="description"
                                placeholder={$t('description')}
                            />
                        </td>
                        <td>
                            <div className="tw-flex tw-items-center tw-gap-x-3.5">
                                <button
                                    type="button"
                                    className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-red"
                                    onClick={props.onCancel}
                                >
                                    <XMarkIcon className="tw-h-3" />
                                    <div>{$t('Cancel')}</div>
                                </button>
                                <button
                                    type="button"
                                    className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue"
                                    disabled={isSubmitting}
                                    onClick={handleSubmit}
                                >
                                    <CircleCheckIcon className="tw-h-3" />
                                    <div>{$t('Save')}</div>
                                </button>
                            </div>
                        </td>
                    </>
                )}
            </Formik>
        </tr>
    );
}
